import PlayerInfoText from './PlayerInfoText';

/**
 * [디지털 카드 텍스트 효과 컴포넌트]
 *
 * @description
 * 디지털 카드의 텍스트 효과를 정의하는 컴포넌트입니다.
 *
 * @features
 * - 플레이어 정보 텍스트 효과
 * ```tsx
 * <DigitalCardEffect.Text.PlayerInfo />
 * ```
 *
 * @see {@link PlayerInfoText} 플레이어 정보 텍스트 효과
 */
const TextEffect = {
  PlayerInfo: PlayerInfoText,
} as const;

export default TextEffect;
